import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { IRefarral } from "@alpha/types";
import { Subject, takeUntil } from "rxjs";
import { Button } from "app-core";
import { UserDummyDataService } from "app-service";

import ButtonType = Data.Core.ButtonType;

@Component({
  selector: 'app-dummy-data-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [UserDummyDataService]
})
export class DummyDataUsersComponent {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public usersControl = new FormControl('', Validators.required);
  public referalByControl = new FormControl('');
  public usersForm!: FormGroup;
  public userCount: number = 0;
  public createUserButton: Button = new Button({
    label: 'Create Users',
    type: ButtonType.button,
    action: () => this.createDummyUsers(
      Number(this.usersControl.value),
      {
        code: '',
        by: {
          _id: this.referalByControl.value?.toString()
        }
      }),
    disabled: () => !this.usersForm!.valid,
  });

  public constructor(
    public readonly _cdRef: ChangeDetectorRef,
    private readonly _formBuilder: FormBuilder,
    private readonly _userDummyDataService: UserDummyDataService
  ) {
    this.usersForm = this._formBuilder.group([this.usersControl]);
  }

  public ngOnInit(): void {
    this.getDummyUsersCount();
  }

  private createDummyUsers(numberOfUsers: number, referalBy: IRefarral): void {
    this._userDummyDataService.createDummyUsers(numberOfUsers, referalBy)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => { },
        () => { },
        () => {
          this.getDummyUsersCount();
        }
      );
  }

  private getDummyUsersCount(): void {
    this._userDummyDataService.getDummyUsersCount()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (count: any) => {
          this.userCount = count.count;
          this._cdRef.markForCheck();
        }
      );
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
